import { render } from "./FormProfissionalMilitar.vue?vue&type=template&id=25784d18&scoped=true"
import script from "./FormProfissionalMilitar.vue?vue&type=script&lang=js"
export * from "./FormProfissionalMilitar.vue?vue&type=script&lang=js"

import "./FormProfissionalMilitar.vue?vue&type=style&index=0&id=25784d18&scoped=true&lang=css"

import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25784d18"]])

export default __exports__